import React, { useState } from "react";
import ShimmerUI from "../ShimmerUI";
import { useParams } from "react-router-dom";
import useRestaurantsMenu from "../utils/hooks/useRestaurantsMenu";
import RestaurentCategory from "./RestaurentCategory";

const RestaurantMenu = () => {
  const [showIndex, setShowIndex] = useState(0);
  const { resId } = useParams();

  const resMenuInfo = useRestaurantsMenu(resId);

  if (resMenuInfo === null) {
    return <ShimmerUI />;
  }

  const {
    name,
    cuisines,
    areaName,
    city,
    avgRating,
    totalRatingsString,
    costForTwoMessage,
  } = resMenuInfo?.cards[2]?.card?.card?.info;

  const { itemCards } =
    resMenuInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards[2]?.card
      ?.card;

  const categories =
    resMenuInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards.filter(
      (c) =>
        c.card["card"]?.["@type"] ===
        "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory"
    );

  return (
    <div className="mt-10 text-center">
      <h2 className="text-decor font-extrabold text-4xl mb-10">{name}</h2>
      <p className="text-decor my-2 tracking-widest">{cuisines.join(",")}</p>
      <p className="text-decor my-2 ">
        {areaName}, {city}
      </p>
      <p className="text-decor">
        {avgRating} ({totalRatingsString}) . {costForTwoMessage}
      </p>
      <h5 className="text-decor font-bold my-7">Menu</h5>

      {/* Title wise menu appeared in accordian */}
      {categories.map((category, index) => (
        <RestaurentCategory
          key={category?.card?.card?.title}
          data={category?.card?.card}
          showIndex={index === showIndex ? true : false}
          setShowIndex={() => setShowIndex(index)}
        />
      ))}
    </div>
  );
};

export default RestaurantMenu;
